/** 折线「全年各月/各季」模式契约 — 与 backend/utils/statistics/statisticsMonthlyYoyPeriod.js 保持一致 */

export const TREND_MODE = {
	PERIODS: 'periods', // 折线「周期」模式
	YEAR_MONTHS: 'year-months', // 折线「全年各月/各季」模式
};

/** 制作图对比：强制横轴汇总粒度（年一点 / 各月 / 各季） */
export const TREND_COMPARE_AXIS_UNIT = {
	YEAR: 'year',
	MONTH: 'month',
	QUARTER: 'quarter',
};

/** 可选年份个数（与后端 statisticsMonthlyYoyPeriod 一致） */
export const TREND_MONTHLY_YEARS_MIN = 2;
export const TREND_MONTHLY_YEARS_MAX = 5;

/** 单个年份合法范围 */
export const TREND_MONTHLY_YEAR_MIN = 2000;
export const TREND_MONTHLY_YEAR_MAX = 2100;

/** 解析年份列表（UI state / query 共用） */
export const normalizeLineCompareMonthlyYears = (value, legacySingleYear = null) => {
	if (Array.isArray(value)) {
		const years = value.map((year) => Number(year)).filter((year) => Number.isFinite(year));
		return [...new Set(years)].sort((a, b) => a - b);
	}
	const legacy = Number(legacySingleYear);
	if (Number.isFinite(legacy)) return [legacy];
	return [];
};

/** 与后端 parseTrendMonthlyYears 同规则：2~5 个、升序去重、年份范围 2000~2100 */
export const parseTrendMonthlyYears = (value) => {
	if (value == null || value === '') return [];

	const raw = Array.isArray(value) ? value : String(value).split(',');
	const years = [
		...new Set(
			raw
				.map((item) => Number.parseInt(String(item).trim(), 10))
				.filter((year) => Number.isFinite(year) && year >= TREND_MONTHLY_YEAR_MIN && year <= TREND_MONTHLY_YEAR_MAX),
		),
	].sort((a, b) => a - b);

	if (years.length < TREND_MONTHLY_YEARS_MIN || years.length > TREND_MONTHLY_YEARS_MAX) {
		return [];
	}
	return years;
};
